module.exports = __webpack_public_path__ + "img/001-clown.70a95990.png";